const LocalStorageKey = {
  APP_STORAGE_PREFIX:
    typeof window !== 'undefined'
      ? `leonardo_${window.location.hostname}_`
      : 'leonardo_',
  USER_PROFILE: 'userProfile',
  AMAZON_STATE: 'amazon_state',
  LINKEDIN_STATE: 'linkedin_state',
  HUBSPOT_STATE: 'hubspot_state',
  TIKTOK_STATE: 'tiktok_state',
  GOOGLE_ADS_STATE: 'google_ads_state',
  REDDIT_STATE: 'reddit_state',
  BING_ADS_STATE: 'bing_ads_state',
  SHOPIFY_STATE: 'shopify_state',
  GOHIGHLEVEL_STATE: 'gohighlevel_state',
  SALESFORCE_STATE: 'salesforce_state',
  SALESFORCE_VERIFIER: 'salesforce_verifier',
  SLACK_STATE: 'slack_state',
  MCP_CONNECTOR_STATE: 'mcp_connector_state',
  MCP_CONNECTOR_PENDING: 'mcp_connector_pending',
  X_ADS_STATE: 'x_ads_state',
  VERIFY_USER_EMAIL: 'verify_user_email',
  MASQUERADE_USER: 'masquerade_user',
  MASQUERADE_OPERATOR_EMAIL: 'masquerade_operator_email',
  SURVEY_FORM_VALUES: 'survey_form_values',
  ACCESS_TOKEN_EXPIRES: 'access_token_expires',
  WORKSPACE: 'workspace',
  // Companion to WORKSPACE for restoring last-active workspace after re-login —
  // {userId, workspaceId|null}. Survives logout; null workspaceId means "home".
  LAST_AUTH_CONTEXT: 'last_auth_context',
  PROMOTER_CODE: 'promoter_code',
  // Carries a dashboard share link across the login redirect (the auth gate
  // strips the query before any effect runs). See utils/dashboardShareLink.ts.
  PENDING_DASHBOARD_SHARE: 'pending_dashboard_share',
  SIDEBAR_AD_FILTERS: 'sidebar_ad_filters',
  WELCOME_BRIEF_EXPLORED: 'welcome_brief_explored',
  PROFESSIONAL_ROLE: 'leo_professional_role',
  PREFERRED_PLATFORMS: 'leo_preferred_platforms',
  ACCOUNT_TYPE: 'leo_account_type',
  AGENCY_FOCUS: 'leo_agency_focus',
  // Carries the federated provider (e.g. 'google', 'linkedin') across the OAuth
  // redirect so the signup-success callback can tag the conversion's `method`.
  FEDERATED_SIGNUP_PROVIDER: 'federated_signup_provider',
} as const;

type LocalStorageKey = (typeof LocalStorageKey)[keyof typeof LocalStorageKey];

export default LocalStorageKey;
